import React, { useEffect, useState } from 'react'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box
} from '@material-ui/core'

import { InfoOutlined } from '@material-ui/icons'
import { useGlobalContext, getLanguage } from '../../../state'

import { useMapEngine } from '../../shared'
import { MAP_ID } from '../../../utils/apiHelper'
import { t } from '../../../utils/languages'

import { spacing } from '../../../theme/index'

export const IndicatorData = () => {
  const [engine] = useMapEngine(MAP_ID)
  const [features, setFeatures] = useState([])
  const [name, setName] = useState('')

  const {
    state: { layers }
  } = useGlobalContext()

  useEffect(() => {
    const selectedLayer = layers.filter(
      ({ kind, isVisible }) => isVisible && kind === 'INDICATOR'
    )[0]
    if (engine && selectedLayer) {
      const {
        metadata: { indicator_name },
        id
      } = selectedLayer
      const { features } = engine.getSource(id)._data

      setName(indicator_name)
      setFeatures(features)
    } else {
      setName('')
      setFeatures([])
    }
  }, [engine, layers])

  const columns = [
    { id: 'country', label: 'País', minWidth: 170 },
    { id: 'city', label: 'Ciudad', minWidth: 170 },
    { id: 'values', label: 'Valor', minWidth: 100 }
  ]
  const rows = features.map(
    ({ properties: { country_name, name_es, name_en, values } }) => ({
      country: country_name
        ? country_name
        : getLanguage() === 'en'
        ? name_en
        : name_es,
      city: country_name ? (getLanguage() === 'en' ? name_en : name_es) : null,
      values
    })
  )

  const containCities = rows.every(({ city }) => city)

  return (
    <Paper style={{ padding: `0px ${spacing * 3}px` }}>
      <TableContainer style={{ maxHeight: 800 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell colSpan={containCities ? 3 : 2}>
                <Box style={{ display: 'flex', alignItems: 'center' }}>
                  <InfoOutlined fontSize="large" style={{ marginRight: 8 }} />
                  <Typography variant="h5">{t('Datos')}</Typography>
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                colSpan={containCities ? 3 : 2}
                style={{
                  top: 55,
                  borderTop: '1px solid black'
                }}
              >
                <Typography variant="h5">{t(name)}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              {columns
                .filter(({ id }) => containCities || id !== 'city')
                .map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{
                      top: 107,
                      minWidth: column.minWidth,
                      borderTop: '1px solid black'
                    }}
                  >
                    <Typography variant="h5"> {t(column.label)}</Typography>
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .sort((a, b) => (a.country > b.country ? 1 : -1))
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns
                      .filter(({ id }) => containCities || id !== 'city')
                      .map((column) => {
                        const value = row[column.id]
                        return (
                          <TableCell key={column.id} align={column.align}>
                            <Typography variant="h6">{value}</Typography>
                          </TableCell>
                        )
                      })}
                  </TableRow>
                )
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}
